/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './series.reducer';

export const SeriesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const seriesEntity = useAppSelector(state => state.series.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="seriesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.series.detail.title">Series</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.series.id">Id</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.id}</dd>
          <dt>
            <span id="seriesInstanceUid">
              <Translate contentKey="tinyMedicRestApp.series.seriesInstanceUid">Series Instance Uid</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.seriesInstanceUid}</dd>
          <dt>
            <span id="seriesNumber">
              <Translate contentKey="tinyMedicRestApp.series.seriesNumber">Series Number</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.seriesNumber}</dd>
          <dt>
            <span id="seriesDescription">
              <Translate contentKey="tinyMedicRestApp.series.seriesDescription">Series Description</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.seriesDescription}</dd>
          <dt>
            <span id="bodyPartExamined">
              <Translate contentKey="tinyMedicRestApp.series.bodyPartExamined">Body Part Examined</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.bodyPartExamined}</dd>
          <dt>
            <span id="patientPosition">
              <Translate contentKey="tinyMedicRestApp.series.patientPosition">Patient Position</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.patientPosition}</dd>
          <dt>
            <span id="laterality">
              <Translate contentKey="tinyMedicRestApp.series.laterality">Laterality</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.laterality}</dd>
          <dt>
            <span id="protocolName">
              <Translate contentKey="tinyMedicRestApp.series.protocolName">Protocol Name</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.protocolName}</dd>
          <dt>
            <span id="operatorsName">
              <Translate contentKey="tinyMedicRestApp.series.operatorsName">Operators Name</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.operatorsName}</dd>
          <dt>
            <span id="seriesDateTime">
              <Translate contentKey="tinyMedicRestApp.series.seriesDateTime">Series Date Time</Translate>
            </span>
          </dt>
          <dd>
            {seriesEntity.seriesDateTime ? <TextFormat value={seriesEntity.seriesDateTime} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.series.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.series.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.series.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.series.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.series.active">Active</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="statusCode">
              <Translate contentKey="tinyMedicRestApp.series.statusCode">Status Code</Translate>
            </span>
          </dt>
          <dd>{seriesEntity.statusCode}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.series.study">Study</Translate>
          </dt>
          <dd>{seriesEntity.study ? seriesEntity.study.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.series.equipment">Equipment</Translate>
          </dt>
          <dd>{seriesEntity.equipment ? seriesEntity.equipment.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/series" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/series/${seriesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SeriesDetail;
